import React from "react";
import { Link } from "react-router-dom";
import ClientPortalLayout from "./ClientPortalLayout";

const ClientDownloads = () => {
  return (
    <ClientPortalLayout
      activeKey="downloads"
      title="Downloads"
      subtitle="Download final signed notices, receipts, and delivery proofs."
      actions={<><Link className="btn btn-light" to="/client-my-notices">My Notices</Link><Link className="btn btn-light" to="/client-dashboard">Dashboard</Link></>}
    >
      <article className="table-panel">
        <div className="search-row">
          <input type="text" placeholder="Search by notice id, file type" />
          <select><option>All File Types</option><option>Final Signed Notice</option><option>Receipt</option><option>Proof of Delivery</option></select>
          <select><option>All Status</option><option>Ready</option><option>Not Ready</option></select>
        </div>
        <div className="table-scroll">
          <table className="crud-table">
            <thead><tr><th>Notice ID</th><th>File Type</th><th>File Name</th><th>Available On</th><th>Status</th><th>Download</th></tr></thead>
            <tbody>
              <tr><td>LN-2028</td><td>Final Signed Notice</td><td>ln2028_signed_notice.pdf</td><td>2026-03-01</td><td>Ready</td><td><button className="tiny-btn">&#9998;</button></td></tr>
              <tr><td>LN-2028</td><td>Receipt</td><td>txn7103_receipt.pdf</td><td>2026-02-25</td><td>Ready</td><td><button className="tiny-btn">&#9998;</button></td></tr>
              <tr><td>LN-2026</td><td>Proof of Delivery</td><td>ln2026_pod.pdf</td><td>Pending</td><td>Not Ready</td><td><button className="tiny-btn">&#9998;</button></td></tr>
            </tbody>
          </table>
        </div>
      </article>
      <div className="pagination-wrap"><p className="pagination-meta">Showing 1-25 of 300</p><div className="pagination"><span className="page-btn active">1</span><span className="page-btn">2</span><span className="page-btn">3</span><span className="page-btn">...</span><span className="page-btn">16</span></div></div>
    </ClientPortalLayout>
  );
};

export default ClientDownloads;
